import React from 'react';
import { HippoComponentProps } from '../index';
import classNames from 'classnames';

import styles from './TextCard.module.scss';

export interface Props extends HippoComponentProps {
  title: string;
  subtitle: string;
  active?: boolean;
  onClick: () => void;
}

const TextCard: React.FC<Props> = ({
  dataQA,
  className,
  title,
  subtitle,
  active,
  onClick,
}) => {
  return (
    <div
      data-qa={dataQA}
      className={classNames(styles.container, className, {
        [styles.active]: active,
      })}
      onClick={onClick}
    >
      <span className={styles.title}>{title}</span>
      <span className={styles.subtitle}>{subtitle}</span>
    </div>
  );
};

export default TextCard;
